import { z } from 'zod';
import { IsoInstantSchema, MoneyCzkSchema } from './common.js';
import { AirshipClassSchema, AirshipStatusSchema } from './enums.js';
import { HubResponseSchema } from './hub.dto.js';
export const AirshipResponseSchema = z.object({
    id: z.number().int().positive(),
    registration: z.string().min(3).max(16),
    name: z.string(),
    model: z.string(),
    airshipClass: AirshipClassSchema,
    capacityPax: z.number().int().positive(),
    maxWindSpeedKts: z.number().int().positive(),
    cruiseSpeedKts: z.number().int().positive(),
    hourlyRateCzk: MoneyCzkSchema,
    status: AirshipStatusSchema,
    turnaroundMinutes: z.number().int().nonnegative(),
    /** BR-09: reservations of this airship need an Approver's decision before CONFIRMED. */
    requiresApproval: z.boolean(),
    homeHub: HubResponseSchema,
    imageUrl: z.string().nullable(),
    description: z.string().nullable(),
});
export const AirshipListQuerySchema = z.object({
    hub: z.string().max(8).optional(),
    airshipClass: AirshipClassSchema.optional(),
    status: AirshipStatusSchema.optional(),
    minCapacity: z.coerce.number().int().positive().optional(),
    maxHourlyRate: z.coerce.number().positive().optional(),
    /** When both are given, each airship is annotated with availability for that window. */
    from: IsoInstantSchema.optional(),
    to: IsoInstantSchema.optional(),
});
/** Airship plus the availability verdict for the queried window (when `from`/`to` were sent). */
export const AirshipWithAvailabilitySchema = AirshipResponseSchema.extend({
    availableInWindow: z.boolean().nullable(),
});
export const CreateAirshipRequestSchema = z.object({
    registration: z
        .string()
        .min(3)
        .max(16)
        .regex(/^[A-Z0-9-]+$/, 'registration must be uppercase letters, digits and dashes'),
    name: z.string().min(2).max(120),
    model: z.string().min(2).max(120),
    airshipClass: AirshipClassSchema,
    capacityPax: z.number().int().positive().max(200),
    maxWindSpeedKts: z.number().int().positive().max(200),
    cruiseSpeedKts: z.number().int().positive().max(200),
    hourlyRateCzk: MoneyCzkSchema,
    homeHubId: z.number().int().positive(),
    turnaroundMinutes: z.number().int().min(0).max(10080).optional(),
    requiresApproval: z.boolean().optional(),
    imageUrl: z.string().url().max(500).optional(),
    description: z.string().max(2000).optional(),
});
export const UpdateAirshipRequestSchema = CreateAirshipRequestSchema.partial()
    .omit({ registration: true })
    .extend({ status: AirshipStatusSchema.optional() });
export const MaintenanceWindowSchema = z.object({
    id: z.number().int().positive(),
    airshipId: z.number().int().positive(),
    startAt: IsoInstantSchema,
    endAt: IsoInstantSchema,
    reason: z.string(),
});
export const CreateMaintenanceWindowRequestSchema = z.object({
    startAt: IsoInstantSchema,
    endAt: IsoInstantSchema,
    reason: z.string().min(3).max(500),
});
//# sourceMappingURL=airship.dto.js.map